import { path } from 'ramda';

import { FEATURE_NAME as $, APP_ERROR, LATEST_NEWS_DATE, BROWSER_COUNTRY } from './consts';

export const getAppError = path([$, APP_ERROR]);
export const getLatestNewsDate = path([$, LATEST_NEWS_DATE]);
export const getBrowserCountry = path([$, BROWSER_COUNTRY]);
